import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29964694"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-header" }
const _hoisted_2 = { class: "header__left" }
const _hoisted_3 = { class: "dialog-footer" }


const __default__ = {
  name: 'commonDialog'
}

import Icon from '@teams/common/components/icon'
import { Type } from 'naive-ui/es/button/src/interface'
import type { Component } from 'vue'

export interface CommonDialog {
  header?: boolean
  footer?: boolean
  title?: string
  className?: string
  message?: string
  dialogContent?: Component
  dialogContentProps?: Record<string, unknown>
  showBackIcon?: boolean
  showCloseIcon?: boolean
  showCancel?: boolean
  okText?: string
  cancelText?: string
  size?: string
  okBtnType?: Type
  cancelBtnType?: Type
  onOk?: (...payload: unknown[]) => unknown
  onCancel?: (...payload: unknown[]) => unknown
  onReturn?: (...payload: unknown[]) => unknown
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    header: { type: Boolean, default: true },
    footer: { type: Boolean, default: true },
    title: null,
    className: null,
    message: null,
    dialogContent: null,
    dialogContentProps: null,
    showBackIcon: { type: Boolean, default: false },
    showCloseIcon: { type: Boolean, default: true },
    showCancel: { type: Boolean, default: true },
    okText: { default: '确定' },
    cancelText: { default: '取消' },
    size: { default: 'medium' },
    okBtnType: { default: 'primary' },
    cancelBtnType: { default: 'default' },
    onOk: null,
    onCancel: null,
    onReturn: null
  },
  emits: ['close', 'back', 'closeAll'],
  setup(__props: any, { emit }) {

const props = __props as { header: boolean, footer: boolean, title?: string, className?: string, message?: string, dialogContent?: Component, dialogContentProps?: Record<string, unknown>, showBackIcon: boolean, showCloseIcon: boolean, showCancel: boolean, okText: string, cancelText: string, size: string, okBtnType: Type, cancelBtnType: Type, onOk?: (...payload: unknown[]) => unknown, onCancel?: (...payload: unknown[]) => unknown, onReturn?: (...payload: unknown[]) => unknown }



const dialogFunc = {
  close: () => {
    emit('close')
  },
  back: () => {
    emit('back')
  },
  closeAll: () => {
    emit('closeAll')
  }
}

const handleOk = async () => {
  await props.onOk?.(dialogFunc)
}

const handleCancel = async () => {
  await (props.onCancel ? props.onCancel(dialogFunc) : dialogFunc.close())
}

const handleBack = async () => {
  await (props.onReturn ? props.onReturn(dialogFunc) : dialogFunc.back())
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      __props.className,
      'common-dialog-container',
      `common-dialog-container--${__props.size || 'auto'}`
    ])
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("span", {
          class: "header__icon header__icon-back",
          onClick: handleBack
        }, [
          _createVNode(_unref(Icon), {
            name: "dialogBack",
            size: 16,
            fill: "transparent"
          })
        ], 512), [
          [_vShow, __props.showBackIcon]
        ]),
        _withDirectives(_createElementVNode("span", { class: "header-title" }, _toDisplayString(__props.title), 513), [
          [_vShow, __props.title]
        ])
      ]),
      _withDirectives(_createElementVNode("span", {
        class: "header__icon header__icon-close",
        onClick: handleCancel
      }, [
        _createVNode(_unref(Icon), {
          name: "close",
          size: 16
        })
      ], 512), [
        [_vShow, __props.showCloseIcon]
      ])
    ], 512), [
      [_vShow, __props.header]
    ]),
    _withDirectives(_createElementVNode("div", { class: "dialog__content" }, _toDisplayString(__props.message), 513), [
      [_vShow, __props.message]
    ]),
    _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(__props.dialogContent), _normalizeProps(_guardReactiveProps(__props.dialogContentProps)), null, 16)), [
      [_vShow, __props.dialogContent]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createVNode(_component_n_space, { size: 16 }, {
        default: _withCtx(() => [
          (__props.showCancel)
            ? (_openBlock(), _createBlock(_component_n_button, {
                key: 0,
                class: "footer-btn",
                type: __props.cancelBtnType,
                onClick: handleCancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.cancelText), 1)
                ]),
                _: 1
              }, 8, ["type"]))
            : _createCommentVNode("", true),
          _createVNode(_component_n_button, {
            class: "footer-btn",
            type: __props.okBtnType,
            onClick: handleOk
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.okText), 1)
            ]),
            _: 1
          }, 8, ["type"])
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, __props.footer]
    ])
  ], 2))
}
}

})